import { Box, Icon, Spacer } from '@jfs/ui-new'
import { Button, ButtonNew } from '../../AdminButton'
import React from 'react'
import { tableItemStrings } from '../../../utils/constants'
import { DropdownOptimised } from '../../DropdownNew'
import { DropdownTypes } from '../../DropdownNew/types'
import { ActionType } from './types'

const getActionView = (
  text: string,
  executeAction: (actionType: ActionType) => void,
  key: string,
  rowIndex?: number,
  disabled?: boolean,
  hide?: boolean,
  from?: string,
  onDownloadFileAction?: (fileType: string) => void,
) => {
  const removeSettlement = () => {
    executeAction(ActionType.RemoveSettlement)
  }

  const handleAction = () => {
    executeAction(ActionType.DownloadSettlementCSV)
  }

  const onPress = () => {
    executeAction(ActionType.Delete)
  }

  const split = text?.toString().split(',') ?? ''
  let value = text
  let iconValue
  if (!!split && split?.length > 0) {
    value = split[0]
    if (split?.length === 2) {
      iconValue = split[1]
    }
  }
  if (value === tableItemStrings.DELETE) {
    return (
      <Button onPress={removeSettlement} color={'ERROR'} type={'IconLH'}>
        {tableItemStrings.deleteCaps}
      </Button>
    )
  }

  const handleOnChange = (data: string | number[]): void => {
    console.log('handleOnChange', data)
  }

  const handleDownload = (fileType: string) => {
    if (onDownloadFileAction) {
      onDownloadFileAction(fileType)
    }
  }

  if (value === 'EXPORT') {
    if (hide) {
      return <Spacer direction={'vertical'} size={50} />
    }
    return (
      <DropdownOptimised
        placeHolder={'Download'}
        buttonLabel="Download Now"
        data={dataExport}
        onChange={handleOnChange}
        onButtonPress={handleDownload}
        type={DropdownTypes.RADIO_BUTTON}
      />
    )
  }

  return (
    <Box flexDirection={'row'}>
      <ButtonNew
        disabled={
          value === tableItemStrings.refunded ||
          value === tableItemStrings.canceled ||
          value === ' Download' ||
          disabled ||
          (key === 'actionHoldRelease' && value === 'Hold/Release')
        }
        onPress={handleAction}
        type={key === 'actionHoldRelease' ? 'primarySmall' : 'textWithIcon'}
        icon={value?.toLowerCase() === 'download' || value?.toLowerCase() === ' download' ? 'DOWNLOAD' : undefined}
        hide={value === '' || hide}
        title={value}
        testID={`downloadActionView${rowIndex}`}
      />
      {!!iconValue && <Spacer direction={'horizontal'} size={8} />}
      {!!iconValue && (
        <Box onPress={onPress}>
          <Icon id={'DELETE'} />
        </Box>
      )}
    </Box>
  )
}

export { getActionView }
